import React from 'react';

import { initializeApollo } from '../../lib/auth/apollo';
import { getNav } from '../../lib/get-nav';
import { PageLayout } from '../../components/page-layout';
import { Box, Flex } from '@chakra-ui/react';
import Link from 'next/link';
import { LogoWordmarkRemarkCompany } from '@outdoorly/logo';
import { Privacy } from '../../components/privacy';

export async function getStaticProps() {
  const apolloClient = initializeApollo();

  await getNav(apolloClient);

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
    },
    revalidate: 100,
  };
}

const PrivacyPage = () => {
  return (
    <PageLayout authWall={false} includeFooter={false} includeHeader={false}>
      <Flex
        as="header"
        bg="scheme.bgPrimary"
        py={6}
        px={8}
        justify="center"
        borderBottomWidth={1}
        borderColor="scheme.border"
      >
        <Flex
          maxW={['full', null, null, '5xl']}
          flexGrow={1}
          justify="space-between"
          align="center"
        >
          <Link href="/" passHref paddingX={3}>
            <Box as="a">
              <LogoWordmarkRemarkCompany height="40px" />
            </Box>
          </Link>
        </Flex>
      </Flex>
      <Privacy />
    </PageLayout>
  );
};

export default PrivacyPage;
